module.exports = __webpack_public_path__ + "static/img/生日福利-主图@2x.089d48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/生日福利-主图@2x.png
// module id = 8V9R
// module chunks = 1